/*
 * @Author: zxf
 * @Date: 2022-07-20 14:23:00
 * @LastEditors: DQL
 * @LastEditTime: 2023-04-25 18:34:55
 * @Description:
 */
import axios from 'axios';
import config from '@/config';

const { iffApi } = config.ctx;
export const hyglService = {

  // 获取检测项目列表
  query: (params) => { return axios.get(`${iffApi}/xfjc/jcxm`, { params: params }); },

  // 导出
  export: (params) => { return axios.get(`${iffApi}/xfjc/jcxm/export`, { responseType: 'blob', params }); },

  // 作废
  delete: (id) => { return axios.delete(`${iffApi}/xfjc/jcxm/${id}`); },

  // 获取详情
  getInfo: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}`); },

  // 新增
  save: (fd) => { return axios.post(`${iffApi}/xfjc/jcxm`, fd); },

  // 更新
  update: (fd) => { return axios.put(`${iffApi}/xfjc/jcxm`, fd); },

  // 获取项目状态
  getStatus: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/status`); },

  // 获取检测结论说明
  getJcjl: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/jcjl`); },

  // 获取系统检测内容列表
  getXtJcnrList: () => { return axios.get(`${iffApi}/xfjc/jcxm/jcnrAll`); },

  // 获取检测项状态
  getJcxStatus: (id) => { return axios.get(`${iffApi}/xfjc/jcxm/${id}/jcx/status`); },

  sqxg: (id, fd) => { return axios.post(`${iffApi}/xfjc/jcxm/${id}/sqxg`, fd); }

};
